import arrayBuffer2BinStr from './arrayBuffer2BinStr';
import arrayBufferToBase64 from './arrayBufferToBase64';
import base64ToArrayBuffer from './base64ToArrayBuffer';
import binStr2ArrayBuffer from './binStr2ArrayBuffer';

const KEY_KEY = 'hpp__a';
const KEY_IV = 'hpp__b';

export function clearAesKeyIv() {
  localStorage.removeItem(KEY_KEY);
  localStorage.removeItem(KEY_IV);
}

function random(byteLength: number) {
  const buffer = new Uint8Array(byteLength);
  for (let i = 0; i < buffer.byteLength; i++) {
    buffer[i] = String(Math.ceil(Math.random() * 10)).charCodeAt(0);
  }
  return buffer;
}

/**
 * 生成一个aes秘钥
 * 如果`localStorage`里面已存在秘钥，则读取使用
 */
export async function generateKey() {
  const storageKey = localStorage.getItem(KEY_KEY);
  let cryptoKey: CryptoKey;
  if (storageKey) {
    const bufferKey = binStr2ArrayBuffer(storageKey);
    cryptoKey = await window.crypto.subtle.importKey('raw', bufferKey, 'AES-CBC', true, ['encrypt', 'decrypt']);
  } else {
    const bufferKey = random(16);
    cryptoKey = await window.crypto.subtle.importKey('raw', bufferKey, 'AES-CBC', true, ['encrypt', 'decrypt']);
    // 初次生成保存到sessionstorage
    const keyBinStr = arrayBuffer2BinStr(bufferKey);
    localStorage.setItem(KEY_KEY, keyBinStr);
  }

  return cryptoKey;
}

/**
 * 生成aes初始向量
 * 如果`localStorage`里面已存在初始向量，则读取使用
 */
export function generateIv() {
  const storageIv = localStorage.getItem(KEY_IV);

  let iv: ArrayBuffer;
  if (storageIv) {
    iv = binStr2ArrayBuffer(storageIv);
  } else {
    iv = random(16);

    const ivBinStr = arrayBuffer2BinStr(iv);
    localStorage.setItem(KEY_IV, ivBinStr);
  }

  return iv;
}

/**
 * aes加密
 * @param data utf8 字符串
 * @returns base64 加密数据
 */
export async function encrypt(data: string, key: CryptoKey, iv: ArrayBuffer) {
  // 将要加密的字符串转成 buffer
  const dataBuffer = new TextEncoder().encode(data);
  const encryptedDataBuffer = await crypto.subtle
    .encrypt(
      {
        name: 'AES-CBC',
        iv,
      },
      key,
      dataBuffer
    )
    .catch(() => null);

  if (!encryptedDataBuffer) {
    return false;
  }

  return arrayBufferToBase64(encryptedDataBuffer);
}

/**
 * 解密
 * @param data base64 加密数据
 * @returns utf8 字符串
 */
export async function decrypt(data: string, key: CryptoKey, iv: ArrayBuffer) {
  // 将base64的加密字符串数据转成 buffer
  const dataBuffer = base64ToArrayBuffer(data);
  const decryptedDataBuffer = await crypto.subtle
    .decrypt(
      {
        name: 'AES-CBC',
        iv,
      },
      key,
      dataBuffer
    )
    .catch(() => null);

  if (!decryptedDataBuffer) {
    return false;
  }

  return arrayBuffer2BinStr(decryptedDataBuffer);
}

export default {
  generateKey,
  generateIv,
  encrypt,
  decrypt,
};
